<template>
  <div v-if="supporter" class="section">
    <div v-if="updateDetails && updateDetails.length > 0">
      <div class="head">
        <div class="title">
          <h3>Update Details Log</h3>
        </div>
      </div>
      <div class="body">
        <SupporterViewUpdateDetails
          :updateDetails="updateDetails"
          @sendLink="open(modalNames.SEND_UPDATE_DETAILS)"
        ></SupporterViewUpdateDetails>
      </div>
    </div>

    <div class="head">
      <div class="title">
        <h3>Donations</h3>
      </div>
      <i
        class="icn icn-refresh mr-2 text-primary-500 refresh"
        title="Refresh donations"
        @click="getSupporterDonations($route.params.id)"
      ></i>
    </div>

    <div class="body halved">
      <!-- On Going donation Section -->
      <div class="details">
        <div class="intro">
          <h4>On Going</h4>
          <a class="edit" v-on:click="open(modalNames.EDIT_PAYMENT)">Edit Details</a>
        </div>
        <div v-if="isLoadingDonations" class="container w-max">
          <div class="flex flex-col items-center">
            <img class="h-36 mt-20" src="@/assets/img/loading.svg" />
            <h2>Fetching donations</h2>
          </div>
        </div>
        <Table
          v-if="!isLoadingDonations"
          :items="regularDonations"
          :attributes="regularTableAttributes"
          :options="regularTableOptions"
          @click="showDetails"
          @edit="showDetails"
        ></Table>
      </div>

      <!-- All donations Section -->
      <div class="details">
        <div class="intro">
          <h4>All Donations</h4>
        </div>
        <div v-if="isLoadingDonations" class="container w-max">
          <div class="flex flex-col items-center">
            <img class="h-36 mt-20" src="@/assets/img/loading.svg" />
            <h2>Fetching donations</h2>
          </div>
        </div>
        <Table
          v-if="!isLoadingDonations"
          :items="allDonations"
          :attributes="tableAttributes"
          :options="tableOptions"
          @click="showDetails"
          @edit="showDetails"
          @head="addDonation()"
        ></Table>
      </div>
    </div>

    <SupporterEditPaymentDetails
      :supporter="supporter"
      v-if="isOpen(modalNames.EDIT_PAYMENT)"
    ></SupporterEditPaymentDetails>

    <SupporterSendUpdateDetails
      :supporter="supporter"
      v-if="isOpen(modalNames.SEND_UPDATE_DETAILS)"
    ></SupporterSendUpdateDetails>

    <div v-if="isLoadingDonationDetail" class="modal">
      <div class="container">
        <div class="flex flex-col items-center">
          <img class="h-36 mt-20 border-raduis" src="@/assets/img/loading.svg" />
          <h2>Fetching donation details</h2>
        </div>
      </div>
    </div>

    <DonationDetailsModal
      v-bind:payload="selectedPayload"
      :showButton="false"
      v-if="!isLoadingDonationDetail && isShowingDetails"
      @close="closeDetailsModal()"
    ></DonationDetailsModal>
  </div>
</template>

<script>
import supporterApi from '@/api/supporters';
import Table from '@/components/Table.vue';
import { CONTACT_TYPE, MESSAGES } from '@/helpers/constants';
import { compareDesc, parseISO } from 'date-fns';
import { mapState } from 'vuex';
import { MODAL_NAME } from '../../stores/supporters';
import DonationDetailsModal from './DonationDetailsModal.vue';
import SupporterEditPaymentDetails from './SupporterEditPaymentDetails.vue';
import SupporterSendUpdateDetails from './SupporterSendUpdateDetails.vue';
import SupporterViewUpdateDetails from './SupporterViewUpdateDetails.vue';

export default {
  name: 'SupporterDonations',
  components: {
    SupporterEditPaymentDetails,
    SupporterSendUpdateDetails,
    DonationDetailsModal,
    SupporterViewUpdateDetails,
    Table,
  },
  data() {
    return {
      allDonations: [],
      donationInterval: null,
      updateDetails: [],
      isShowingDetails: false,
      isLoadingDonations: false,
      isLoadingDonationDetail: false,
      selectedPayload: null,
      tableOptions: {
        headAction: 'Add donation',
        edit: true,
        editLabel: 'View',
        pages: [5, 10, 20],
      },
      tableAttributes: [
        { name: 'donationDate', label: 'Date', type: 'date' },
        { name: 'type', label: 'Type' },
        { name: 'amount', label: 'Amount', type: 'currency' },
        { name: 'paymentType', label: 'Payment', type: 'image' },
        { name: 'status', label: 'Status' },
      ],
      regularTableOptions: {
        edit: true,
        editLabel: 'View',
        pages: [5, 10, 20],
      },
      regularTableAttributes: [
        { name: 'donationDate', label: 'Date', type: 'date' },
        { name: 'type', label: 'Type' },
        { name: 'amount', label: 'Amount', type: 'currency' },
        { name: 'paymentType', label: 'Payment', type: 'image' },
      ],
    };
  },

  computed: {
    ...mapState({
      newDonationPayload: (state) => state.donationModal.payload,
    }),
    // canEdit() {
    //   return this.$store.getters['auth/hasAccess'](MODULE.SUPPORTER, [PERMISSION.EDIT]);
    // },
    modalNames() {
      return MODAL_NAME;
    },
    regularDonations() {
      return this.allDonations.filter(
        (donation) => donation.type === 'regular' && donation.status === 'completed' && donation.isActive,
      );
    },
  },
  props: {
    supporter: Object,
  },
  watch: {
    '$route.params.id': function (id) {
      this.getSupporterDonations(id);
    },
    supporter() {
      this.processSupporter();
    },
  },

  mounted: function () {
    this.donationInterval = setInterval(this.checkDonationStatus, 10000);
    this.getSupporterDonations(this.$route.params.id);
    this.processSupporter();
  },

  methods: {
    processSupporter() {
      if (this.supporter) {
        // Extract the emails from the supporter
        let emails = [];
        if (this.supporter.contacts) {
          emails = this.supporter.contacts.filter((e) => e.type === CONTACT_TYPE.EMAIL).map((e) => e.contact);
        }

        this.$store
          .dispatch('supporters/getUpdateDetails', { supporterId: this.supporter.id, emails: emails })
          .then(({ data }) => {
            this.updateDetails = data;
          });
      }
    },
    isOpen(modalName) {
      return this.$store.getters['supporters/isOpen'](modalName);
    },
    open(modalName) {
      this.$store.commit('supporters/open', modalName);
    },
    getSupporterDonations(id) {
      this.isLoadingDonations = true;
      // console.log('Get donations for supporter ', id);
      supporterApi.getDonations(id).then((donations) => {
        this.concatDonationsAndTransactions(donations.data);
        this.isLoadingDonations = false;
      });
    },
    concatDonationsAndTransactions(donations) {
      let donationsAndTransactions = [];
      donations.forEach((d) => {
        if (d.transactions && d.transactions.length > 0) {
          d.status = d.transactions[d.transactions.length - 1].status;
        }
        donationsAndTransactions.push(d);
      });

      // console.log('Donations and Transactions ', donationsAndTransactions.length, donationsAndTransactions);

      this.allDonations = donationsAndTransactions
        .map((d) => {
          d.amount = d.amount ? Number.parseFloat(d.amount).toFixed(2) : '00.00';

          // Format date
          if (d.donationDate) {
            d.date = new Date(d.donationDate);
            d.dateFormated = d.date.toLocaleString().split(',')[0];
          } else if (d.transactionDate) {
            d.date = new Date(d.transactionDate);
            d.dateFormated = d.date.toLocaleString().split(',')[0];
          } else {
            d.dateFormated = '';
          }

          return d;
        })
        .sort((a, b) => b.date - a.date);

      this.totalPages = Math.ceil(this.allDonations.length / this.donationsPerPage);
      // console.log('Alldonations ', this.allDonations, 'displayed donations', this.donations);
    },
    async addDonation() {
      clearInterval(this.donationInterval);
      this.$emit('close');

      this.$store.commit('donationModal/updateAddDonation', true);

      // Open a new donation
      this.$store.dispatch('donationModal/reset');
      this.$store.dispatch('donationModal/open');
      console.log('supporter', this.supporter);

      // Fill in the supporter's details
      const supporter = this.supporter;
      const email = this.supporter.contacts
        .filter((contact) => contact.type === CONTACT_TYPE.EMAIL && contact.isActive)
        .sort((a, b) => (b.isPrimary ? 1 : -1))[0];
      const phone = this.supporter.contacts
        .filter((contact) => contact.type === CONTACT_TYPE.PHONE && contact.isActive)
        .sort((a, b) => (b.isPrimary ? 1 : -1))[0];

      this.newDonationPayload.supporter = {
        ...this.newDonationPayload.supporter,
        id: supporter.id,
        title: supporter.title,
        firstName: supporter.firstName,
        lastName: supporter.lastName,
        phoneNumber: phone ? phone.contact : '',
        email: email ? email.contact : '',
      };

      const address = this.supporter.addresses.sort((a, b) => (b.isPrimary ? 1 : -1))[0];
      this.newDonationPayload.billingAddress = {
        label: address.label,
        unitNumber: address.unitNumber,
        streetNumber: address.streetNumber,
        streetName: address.streetName,
        suburb: address.suburb,
        postalCode: address.postalCode,
        state: address.state,
        country: address.country,
      };

      // Might need to be updated to search through all supporter address
      [this.newDonationPayload.countryCode] = await this.$store.dispatch('supporters/getCountryCodesByCountries', [
        address.country,
      ]);
      console.log('this.newDonationPayload.countryCode', this.newDonationPayload.countryCode);
      console.log(supporter.isOptingIn);
      this.newDonationPayload.donation = {
        ...this.newDonationPayload.donation,
        isOptingIn: supporter.isOptingIn,
        contactForBequest: supporter.contactForBequest,
        isOnBehalfOfBusiness: !!supporter.businessName,
        businessName: supporter.businessName,
      };
      console.log(this.newDonationPayload);
    },
    async showDetails(payload) {
      try {
        this.isLoadingDonationDetail = true;
        console.log('pandata', payload);
        // Get data from firestore
        const webDonationModel = (await this.$store.dispatch('donationModal/getDonation', payload.webId))
          .webDonationModel;
        console.log('firestore', webDonationModel);

        // Choose the latest transaction from this donation
        const transaction = payload.transactions.sort((a, b) =>
          compareDesc(parseISO(a.updatedAt), parseISO(b.updatedAt)),
        )[0];

        if (!transaction) {
          this.$store.dispatch('notifications/error', {
            headline: MESSAGES.ERROR_FETCH,
            details: 'Cannot find transaction for this donation.',
          });
        } else {
          const supporter = {
            title: this.supporter.title,
            firstName: this.supporter.firstName,
            lastName: this.supporter.lastName,
          };

          const donation = {
            ...payload,
            fundId: payload.fundLookupId,
            appealId: payload.appealLookupId,
            businessName: this.supporter.businessName,
            amount: payload.amount,
            type: payload.type,
            campaignId: payload.campaignLookupId,
            packageCode: payload.packageLookupId,
            webId: payload.webId,
            giftAddress: webDonationModel.gift,
          };

          const donationProductDetails = {
            id: payload.productId,
            productname: payload.productId,
            producttype: '',
          };

          const addressFullLine =
            (payload.billingAddress ? `${payload.billingAddress.addressLines}, ` : '') +
            (payload.billingAddress.suburb ? `${payload.billingAddress.suburb} ` : '') +
            (payload.billingAddress.state ? `${payload.billingAddress.state} ` : '') +
            (payload.billingAddress.postalCode ? `${payload.billingAddress.postalCode}, ` : '') +
            (payload.billingAddress.country ? payload.billingAddress.country : '');

          // Construct the payload
          this.selectedPayload = {
            createdAt: payload.createdAt,
            paymentCaptureSystem: webDonationModel ? webDonationModel.paymentCaptureSystem : null,
            agentEmail: webDonationModel ? webDonationModel.agentEmail : null,
            addressFullLine,
            supporter,
            donation,
            transaction,
            donationProductDetails,
          };
          this.isShowingDetails = true;
        }
        this.isLoadingDonationDetail = false;
      } catch (err) {
        this.isLoadingDonationDetail = false;
        console.log(err);
      }
    },
    closeDetailsModal() {
      this.isShowingDetails = false;
      this.selectedPayload = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  float: right;
  margin-top: -50px;

  button {
    padding: 0;
    min-width: 40px;

    &:disabled path {
      stroke: #9fa6b2 !important;
    }
  }
}

.font-italic {
  font-style: italic;
}

.pointer:hover {
  cursor: pointer;
}

.pointer {
  padding-top: 10px;
}
.no-results {
  @apply p-4 font-light font-italic;
}
</style>
